<div class="container">

  <form class="likes-form" [formGroup]="engagementFormGroup">

    <mat-form-field appearance="outline" class="post-url compact-form">
      <mat-label>קישור או שם משתמש</mat-label>
      <input matInput formControlName="userUrl" />

      @if (engagementFormGroup.get('userUrl')?.hasError('required')) {
        <mat-error>
          שדה חובה
        </mat-error>
      }

      @if (engagementFormGroup.get('userUrl')?.hasError('pattern')) {
        <mat-error>
          פורמט לא תקין - הזן קישור טיקטוק או @שם_משתמש
        </mat-error>
      }
    </mat-form-field>

    <div class="row-container">

      <mat-form-field appearance="outline" class="number-of-likes compact-form">
        <mat-label>מספר עוקבים</mat-label>
        <input matInput type="number" inputmode="numeric" formControlName="numberOfFollows" (keypress)="onlyNumbers($event)" />
        <mat-error>
          שדה חובה
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="seconds-between-likes compact-form">
        <mat-label>שניות בין עוקבים</mat-label>
        <input matInput type="number" inputmode="numeric" formControlName="secondsBetweenFollows" (keypress)="onlyNumbers($event)" />
        <mat-error>
          שדה חובה
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="date-picker-field compact-form">
        <mat-label>בחר תאריך</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="startDate">
        <mat-hint>DD.MM.YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="time-picker-field compact-form">
        <mat-label>שעה</mat-label>
        <input matInput type="time" formControlName="startTime">
      </mat-form-field>

    </div>

    @if (engagementFormGroup.hasError('avatarCountError')) {
      <mat-error>שגיאה בבדיקת מספר אוואטרים</mat-error>
    }
    @if (engagementFormGroup.hasError('insufficientAvatars')) {
      <mat-error>
        שגיאה: ישנם רק {{ engagementFormGroup.errors?.['insufficientAvatars'].available }} אווטארים באזור,
        אך דרושים {{ engagementFormGroup.errors?.['insufficientAvatars'].required }} עבור העוקבים
      </mat-error>
    }

    @if ({ val: (countAvatarsInGroup$ | async) }; as data) {
      @if (data.val !== null && !engagementFormGroup.errors) {
        <div class="avatar-info">
          מספר העוקבים מוגבל ל- {{ data.val }} בהתאם למספר האווטארים באזור
        </div>
      }
    }

    @if (engagementFormGroup.pending) {
      <span>בודק חוקיות נתונים..</span>
    }

  </form>

</div>
